import { Link, useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';
import {
  Settings,
  Lock,
  FileText,
  ThumbsUp,
  Activity,
  ArrowLeft,
} from 'lucide-react';

const navItems = [
  {
    label: 'Settings',
    href: '/profile/settings',
    icon: Settings,
  },
  {
    label: 'Security',
    href: '/profile/security',
    icon: Lock,
  },
  {
    label: 'My Posts',
    href: '/profile/posts',
    icon: FileText,
  },
  {
    label: 'My Votes',
    href: '/profile/votes',
    icon: ThumbsUp,
  },
  {
    label: 'Activity',
    href: '/profile/activity',
    icon: Activity,
  },
];

export function ProfileSidebar() {
  const { pathname } = useLocation();

  return (
    <aside className="w-[200px] border-r bg-card min-h-screen">
      <div className="p-6">
        <h2 className="text-lg font-semibold">Profile</h2>
        <p className="text-sm text-muted-foreground">Manage your account</p>
      </div>

      <nav className="px-3 space-y-1">
        {navItems.map((item) => {
          const isActive = pathname === item.href;
          const Icon = item.icon;

          return (
            <Link
              key={item.href}
              to={item.href}
              className={cn(
                'px-3 py-2 text-sm font-medium rounded-md flex items-center gap-2 transition-colors',
                isActive
                  ? 'bg-muted text-foreground'
                  : 'text-muted-foreground hover:text-foreground hover:bg-muted'
              )}
            >
              <Icon className="h-4 w-4" />
              {item.label}
            </Link>
          );
        })}
      </nav>

      <div className="px-3 mt-8">
        <Link
          to="/boards"
          className="px-3 py-2 text-sm font-medium rounded-md flex items-center gap-2 text-muted-foreground hover:text-foreground hover:bg-muted transition-colors"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to site
        </Link>
      </div>
    </aside>
  );
}
